import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");

  const opt = getCookie('opt');
  const user = getCookie('user');

  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) { return value; }
    }
    return null;
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault(); // Prevent form from refreshing the page
    if (searchTerm.trim() !== "") {
      navigate(`/allCustomer/${searchTerm}`);
    }
  };

  return (
    <nav className={`main-header navbar elevation-2 navbar-expand bg-dark text-white`}>
      <ul className="navbar-nav">
        <li className="nav-item mx-2">
          <a className="nav-link px-0 px-lg-2" data-widget="pushmenu" href="#" role="button">
            <i className="fas fa-bars text-white" />
          </a>
        </li>
       
        <li className="nav-link">
          <span className="h5 text-orange">{opt}</span>
        </li>
      </ul>
      <ul className="navbar-nav ml-auto">
        <li className="nav-item">
          <Link className="nav-link btn bg-gradient-danger text-white p-1 py-2" to="/login" role="button">
            LogOut
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Header;
